<template>
  <div :class="orientation === 'row' ? 'row' : ''">
    <q-input
      class="flex-fill"
      dense
      outlined
      label="Начало периода"
      :debounce="250"
      :mask="inputMask"
      :clearable="clearable"
      :model-value="dateRangeFrom"
      @update:model-value="dateRangeFromChange"
    >
      <template v-slot:prepend>
        <q-icon name="event" class="cursor-pointer">
          <q-popup-proxy>
            <q-date
              minimal
              :mask="dateTimeMask"
              :model-value="dateRangeFrom"
              @update:model-value="dateRangeFromChange"
            />
          </q-popup-proxy>
        </q-icon>
      </template>
      <template v-if="withTime" v-slot:append>
        <q-icon name="access_time" class="cursor-pointer">
          <q-popup-proxy>
            <q-time
              format24h
              :mask="dateTimeMask"
              :model-value="dateRangeFrom"
              @update:model-value="dateRangeFromChange"
            />
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>

    <span class="q-mx-sm"></span>

    <q-input
      class="flex-fill"
      dense
      outlined
      label="Конец периода"
      :debounce="250"
      :mask="inputMask"
      :clearable="clearable"
      :model-value="dateRangeTo"
      @update:model-value="dateRangeToChange"
    >
      <template v-slot:prepend>
        <q-icon name="event" class="cursor-pointer">
          <q-popup-proxy>
            <q-date
              minimal
              :mask="dateTimeMask"
              :model-value="dateRangeTo"
              @update:model-value="dateRangeToChange"
            >
            </q-date>
          </q-popup-proxy>
        </q-icon>
      </template>
      <template v-if="withTime" v-slot:append>
        <q-icon name="access_time" class="cursor-pointer">
          <q-popup-proxy>
            <q-time
              format24h
              :mask="dateTimeMask"
              :model-value="dateRangeTo"
              @update:model-value="dateRangeToChange"
            />
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>

    <span v-if="orientation === 'row'" class="q-mx-sm"></span>
    <q-btn icon="date_range" flat>
      <q-popup-proxy @hide="dateRangePopupHide">
        <q-date
          v-model="dateRange"
          range
          minimal
          :mask="dateTimeMask"
          @update:model-value="dateRangeChange"
        />
      </q-popup-proxy>
      <q-tooltip> Период </q-tooltip>
    </q-btn>
  </div>
</template>

<script>
import { date, debounce } from "quasar";

export default {
  name: "DateRange",
  props: {
    orientation: {
      type: String,
      default: "row",
    },
    modelValue: {
      type: Object,
      default: () => ({
        from: undefined,
        to: undefined,
      }),
    },
    from: String,
    to: String,
    clearable: {
      type: Boolean,
      default: true,
    },
    withTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateRange: undefined,
      dateRangeFrom: undefined,
      dateRangeTo: undefined,
      dateTimeMask: this.withTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD",
      inputMask: this.withTime ? "####-##-## ##:##" : "####-##-##",
    };
  },
  watch: {
    from() {
      this.dateRangeFromChange(this.from);
    },
    to() {
      this.dateRangeToChange(this.to);
    },
  },
  methods: {
    init() {
      this.dateRangeFrom = this.from || this.modelValue?.from;
      this.dateRangeTo = this.to || this.modelValue?.to;
      this.dateRange = {
        from: this.dateRangeFrom,
        to: this.dateRangeTo,
      };
    },
    getValidDate(value) {
      if (value && date.isValid(value)) {
        return value;
      } else {
        return this.clearable
          ? ""
          : date.formatDate(new Date(), this.dateTimeMask);
      }
    },
    dateRangeChange(newValue) {
      this.dateRangeFromChange(this.dateRange?.from || "");
      this.dateRangeToChange(this.dateRange?.to || "");
      this.emitInput();
    },
    dateRangeFromChange(newValue) {
      this.dateRangeFrom = this.getValidDate(newValue);
      if (this.dateRange?.from) {
        this.dateRange.from = this.dateRangeFrom;
      } else {
        this.dateRange = {
          to: this.dateRangeFrom.to || "",
          from: this.dateRangeFrom,
        };
      }
      this.emitInput();
    },
    dateRangeToChange(newValue) {
      this.dateRangeTo = this.getValidDate(newValue);
      if (this.dateRange?.to) {
        this.dateRange.to = this.dateRangeTo;
      } else {
        this.dateRange = {
          from: this.dateRangeFrom.from || "",
          to: this.dateRangeTo,
        };
      }
      this.emitInput();
    },
    dateRangePopupHide() {
      if (!this.dateRange) {
        this.dateRange = {
          from: this.dateRangeFrom,
          to: this.dateRangeTo,
        };
      }
    },
    emitInput() {
      if (this.dateRange) {
        this.$emit("update:from", this.dateRangeFrom);
        this.$emit("update:to", this.dateRangeTo);
        this.$emit("update:model-value", this.dateRange);
      }
    },
  },
  created() {
    this.init();
    this.emitInput = debounce(this.emitInput, 250);
  },
};
</script>

<style lang="scss"></style>
